import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AgreementTemplateComponent } from './agreement-template.component';

const routes: Routes = [{ path: '', component:AgreementTemplateComponent,pathMatch: "full"}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AgreementTemplateRoutingModule { }
